let functionAuthorizePlugin = {
  install (Vue, options) {
    /**
     * 功能权限校验
     * @param url 功能url
     * @returns {boolean} 是否有权限
     */
    Vue.prototype.permitFunction = function (url) {
      let urlApis = this.$store.state.serverApis.urlApis
      let regexApis = this.$store.state.serverApis.regexApis
      let api = urlApis[url]
      if (!api) {
        url = url.replace(':', '')
        for (let index in regexApis) {
          let regexApi = regexApis[index]
          if (regexApi.pattern.test(url)) {
            api = regexApi
          }
        }
      }
      if (api) {
        if (api.serviceLevel === 0) {
          return true
        } else if (api.serviceLevel === 1) {
          return true
        } else if (api.serviceLevel === 2) {
          return api.authResult === 1
        }
      } else {
        return true
      }
    }
  }
}

export default functionAuthorizePlugin



// WEBPACK FOOTER //
// ./src/plugins/FunctionAuthorizePlugin.js